// This is essentially bulk require
var req = require.context('../locales', true, /\.json.*$/);
var exports = {};
exports.locales = {};

req.keys().forEach(function (file) {
    var locale = file.replace('./', '').replace('.json', '');
    exports.locales[locale] = req(file);
});

exports.getLocale = function () {
    let locale = 'en';

    //Is prefered language set?
    if (typeof localStorage !== 'undefined' && localStorage.getItem('preferedLanguage') !== undefined && localStorage.getItem('preferedLanguage') !== null) {
        locale = localStorage.getItem('preferedLanguage');
    } else if (typeof navigator !== 'undefined' && navigator.language) {
        //Use browser language
        locale = (navigator.language.includes('-') ? navigator.language.split('-')[0] : navigator.language) || 'en';

        //Set preferedLanguage if localization is available
        if (exports[locale]) {
            localStorage.setItem('preferedLanguage', locale);
        } else {
            localStorage.setItem('preferedLanguage', 'en');
        }
    }
    return locale;
};

exports.getLocalizedStrings = function () {
    let locale = exports.getLocale();
    let strings;
    if (exports.locales[locale]) {
        strings = exports.locales[locale];
    } else {
        strings = exports.locales.en;
        exports.locales[locale] = strings;
    }
    strings = Object.assign(exports.locales[locale], strings);
    return strings;
};

module.exports = exports;



// WEBPACK FOOTER //
// /src/messages.js